export default "/images/vendor/flag-icons/flags/4x3/sh-hl.svg?0e216f1ae201988c57c0e415c07fe08c";